<div class="cell cell-large-col-span-12" *ngIf="appointmentList?.length">
  <open-tile-block
    [title]="'Upcoming appointment'"
    [text]="getAppointmentText()"
    [tileClass]="'info-notification'"
    [icon]="'management-updatetraveldates'"
    [noAction]="true"
  ></open-tile-block>
</div>
